module.exports = __webpack_public_path__ + "img/logo-top.62911cd5.png";